<template>
  <div id="navbar" :class="[meta.navbar, meta.backDesktop && 'have-back']" v-if="$route.meta.navbar !== false">
    <div v-if="meta.backDesktop" class="back-desktop" @click="$router.go(-1)">
      <img src="@/assets/icons/back-mini.svg" alt="back" />
      <span>{{ $t('back') }}</span>
    </div>
    <div class="navbar-wrapper">
      <div class="back" @click="$router.go(-1)">
        <img src="@/assets/icons/back.svg" alt="back" />
      </div>
      <h1 class="pageName">{{ name }}</h1>
      <div class="menu" @click="openMenu">
        <img src="@/assets/icons/menu.svg" alt="menu" />
        <div class="dot-new" v-if="notificationNew"></div>
      </div>
      <navbar-profile class="hide-mobile" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import NavbarProfile from '@/components/navbar/NavbarProfile'

export default {
  name: 'navbar',
  components: { NavbarProfile },
  computed: {
    meta() {
      return this.$route.meta
    },
    name() {
      if (this.meta.paramTitle) {
        return this.$route.params[this.meta.paramTitle]
      }
      return this.meta?.title || this.localePageName || this.$route?.name
    },
    localePageName() {
      if (this.meta?.langKey) {
        return this.$t(`page-names.${this.meta.langKey}`)
      }
      return ''
    },
    ...mapGetters('events', ['notificationNew']),
  },
  methods: {
    openMenu() {
      this.$store.commit('openMenu')
    },
  },
}
</script>
<style lang="scss">
#navbar {
  width: 100%;
  width: calc(100% - 160px);
  max-width: 1190px;
  padding: 28px 30px 35px;

  @include mobile {
    width: 100%;
    padding: 15px 20px !important;
  }

  &.dashboard {
    @include PC {
      &::after {
        content: '';
        display: block;
        width: 304px;
        flex-shrink: 0;
      }
    }
  }

  .navbar-wrapper {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 0 !important;

    @include mobile {
      align-items: center;
    }
  }

  .menu {
    position: relative;

    .dot-new {
      top: 0;
      right: -2px;
      width: 8px;
      height: 8px;
      background: $primary;
      position: absolute;
      border-radius: 50%;
      margin: 0 !important;
    }
  }

  .back {
    padding-left: 5px;
  }

  .pageName {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 0;
    padding: 0 5px 0 0;
  }

  &.absolut {
    @include PC {
      position: absolute;

      .navbar-wrapper {
        justify-content: flex-end;
      }

      .pageName,
      .back {
        display: none;
      }
    }
  }

  &.have-back {
    display: block;

    .pageName {
      text-align: left;
    }

    .navbar-profile {
      margin-top: -28px;
    }
  }

  @include mobile {
    background: $white;
    border-bottom: 1px solid rgba($dark, 0.13);
    &.have-back {
      display: flex;

      .pageName {
        text-align: center;
      }
    }
  }

  @include PC {
    padding: 0;
    margin: 31px 0px 24px 72px;
    .back,
    .menu {
      display: none;
    }
  }
}

.back-desktop {
  position: relative;
  top: -6px;
  display: inline-flex;
  align-items: center;
  color: #9fa0a0;
  font-weight: bold;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  padding: 0 0 10px;
  text-transform: capitalize;

  @include mobile {
    display: none;
  }

  img {
    margin-right: 8px;
  }
}
</style>
